module.exports = __webpack_public_path__ + "static/media/answerPage6.cd88c24b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPage6.png
// module id = 734
// module chunks = 0 1